import React from 'react';
import { Link } from 'react-router-dom';
import { usePathway } from '../../../hooks';
import { CreatePathwayItem, IBLSpinLoader } from '../../../components';

export const PathwayViewContent = ({ pathwayID }) => {
  const [pathwayDetailData, pathwayDetailDataLoaded] = usePathway(pathwayID);

  if (!pathwayDetailDataLoaded) {
    return <IBLSpinLoader size={40} containerHeight="150px" />;
  }

  const hasData = pathwayDetailData && pathwayDetailData.length > 0;
  const pathwayData = hasData ? pathwayDetailData[0] : {};

  return (
    <div className="pathway">
      <div className="div-block-110">
        <div className="pathway_div">
          <div className="div-block-121"></div>
          <div className="text-block-58">
            {
              <>
                <Link className="w_link" to="#">
                  {pathwayData?.name}{' '}
                </Link>
                &gt;
                <Link className="w_link" to="#">
                  {' '}
                  Pathway
                </Link>
              </>
            }
          </div>
          <div className="div-block-75">
            <div className="p_header">
              <div className="text-block-39 wide p_t wt">
                {pathwayData?.name}
                <strong></strong>
              </div>
              {pathwayDetailDataLoaded && (
                <div className="unit-wide-description people profile_description p_t wto">
                  {`${pathwayData?.path?.length} Items`}
                  <span className="dash"></span> <span className="dash"></span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="p_about">
          <div className="text-block-57">
            {
              <>{pathwayData?.data?.description}</>
            }
          </div>
        </div>
      </div>
      <div className="p_outline">
        {
          pathwayData?.path?.map((data, index) => (
            <CreatePathwayItem key={index} data={data} index={index} />
          ))}
      </div>
    </div>
  );
};